<fa-layers>
  <fa-icon [icon]="['far','file']"></fa-icon>
  <fa-layers-text content="R" style="font-size: 0.6em; font-weight: bold;"></fa-layers-text>
</fa-layers>
<ng-content></ng-content>
